import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Navbar.css';

const navItems = [
  { path: '/', key: 'nav.home' },
  { path: '/nos-services', key: 'nav.services' },
  { path: '/vivre-en-espagne', key: 'nav.vivre' },
  { path: '/reconnaissance-des-diplomes', key: 'nav.reconnaissance' },
  { path: '/documents-demarches', key: 'nav.documents' },
  { path: '/diagnostic', key: 'nav.diagnostic' },
  { path: '/collaborateurs', key: 'nav.collaborateurs' },
  { path: '/temoignages', key: 'nav.temoignages' },
  { path: '/paiement', key: 'nav.paiement' },
  { path: '/consultoria-marruecos', key: 'nav.consultoria' },
];

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [isMenuOpen]);

  const closeMenu = () => setIsMenuOpen(false);
  const isActive = (path) => location.pathname === path;

  const { t, i18n } = useTranslation();
  const currentLanguage = (i18n.resolvedLanguage || i18n.language || 'fr').split('-')[0];
  const changeLanguage = (lng) => i18n.changeLanguage(lng);

  return (
    <>
      <nav className={`navbar fixed-top ${isScrolled ? 'navbar-scrolled' : ''}`}>
        <div className="container">
          <Link className="navbar-brand" to="/">
            <span className="navbar-logo-circle">
              <img src="/images/logo.jpeg" alt="Logo IBERMAROC BRIDGE" />
            </span>
            <div className="logo-container">
              <span className="logo-text">IBERMAROC</span>
              <span className="logo-subtitle">BRIDGE</span>
            </div>
          </Link>
          <div className="navbar-lang">
            <button
              type="button"
              className={`navbar-lang-option ${currentLanguage === 'en' ? 'active' : ''}`}
              onClick={() => changeLanguage('en')}
              aria-label="Switch language to English"
            >
              en
            </button>
            <span className="navbar-lang-separator">|</span>
            <button
              type="button"
              className={`navbar-lang-option ${currentLanguage === 'fr' ? 'active' : ''}`}
              onClick={() => changeLanguage('fr')}
              aria-label="Passer la langue en français"
            >
              fr
            </button>
            <span className="navbar-lang-separator">|</span>
            <button
              type="button"
              className={`navbar-lang-option ${currentLanguage === 'es' ? 'active' : ''}`}
              onClick={() => changeLanguage('es')}
              aria-label="Cambiar el idioma a español"
            >
              es
            </button>
          </div>
          <button
            className={`navbar-menu-btn ${isMenuOpen ? 'navbar-menu-btn-open' : ''}`}
            type="button"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label={isMenuOpen ? t('common.closeMenu') : t('common.openMenu')}
            aria-expanded={isMenuOpen}
          >
            <span className="navbar-menu-btn-line" />
            <span className="navbar-menu-btn-line" />
            <span className="navbar-menu-btn-line" />
          </button>
        </div>
      </nav>

      <div
        className={`fullscreen-menu-overlay ${isMenuOpen ? 'fullscreen-menu-open' : ''}`}
        aria-hidden={!isMenuOpen}
      >
        <div className="fullscreen-menu-backdrop" onClick={closeMenu} />
        <div className="fullscreen-menu-content">
          <button
            className="fullscreen-menu-close"
            type="button"
            onClick={closeMenu}
            aria-label={t('common.closeMenu')}
          >
            <span className="fullscreen-menu-close-icon">×</span>
          </button>
          <nav className="fullscreen-menu-nav" role="navigation">
            <ul className="fullscreen-menu-list">
              {navItems.map((item) => (
                <li key={item.path} className="fullscreen-menu-item">
                  <Link
                    className={`fullscreen-menu-link ${isActive(item.path) ? 'active' : ''}`}
                    to={item.path}
                    onClick={closeMenu}
                  >
                    {t(item.key)}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        </div>
      </div>
    </>
  );
};

export default Navbar;
